/** Our parent company — linked from the hero, the footer and the imprint */
export const parentCompany = {
  name: 'Syne',
  label: 'Visit Syne',
  href: 'https://syne.digital/',
};
